module.exports = __webpack_public_path__ + "img/wechat-notice.dec7af87.png";